<div
  class="predefined-chart"
  [class.predefined-chart--large]="isLargeView"
  [attr.color-palette]="colorPalette"
  [id]="exportRootId"
  #chartCard
>
  <div class="predefined-chart-header">
    <h3 class="chart-title">{{ chartTitle }}</h3>
    <div class="chart-header-actions">
      @if (showGranularityDropdown) {
        <select
          class="granularity-select"
          [ngModel]="selectedGranularityHours"
          (ngModelChange)="onGranularityChange($event)"
          aria-label="Time bucket granularity"
        >
          @for (option of granularityOptions; track option.value) {
            <option [ngValue]="option.value">{{ option.label }}</option>
          }
        </select>
      }
      @if (showChartActions) {
        <div class="chart-actions">
        @if (!isLargeView) {
          <button
            type="button"
            class="btn view-download-btn"
            (click)="onViewInLarge()"
            matTooltip="View Chart"
          >
            <img src="assets/icons/view-icon-grey.svg" alt="View chart" />
          </button>
        }
        <button
          type="button"
          class="btn view-download-btn"
          (click)="exportChart()"
          matTooltip="Export Chart"
        >
          <img src="assets/icons/export_icon_grey.svg" alt="Export chart" />
        </button>
      </div>
      }
    </div>
  </div>
  <div class="chart-body">
    @if (loading) {
      <div class="chart-loading">
        <div class="spinner"></div>
        <span>Loading chart...</span>
      </div>
    } @else if (errorMessage) {
      <div class="chart-error">
        <p>{{ errorMessage }}</p>
      </div>
    } @else if (!chartData) {
      <div class="chart-empty">
        <p>No chart data available.</p>
      </div>
    } @else if (chartData.NoDataFound) {
      <div class="chart-empty">
        <p>No data found for the selected filters and date range.</p>
      </div>
    } @else {
      <div class="chart-container">
        <highcharts-chart
          [Highcharts]="Highcharts"
          [options]="chartOptions"
          [oneToOne]="true"
          (chartInstance)="chartRef = $event"
        ></highcharts-chart>
      </div>
    }
  </div>
</div>
